<template>
  <div class="content content--secondary">
    <div class="single-column">
      <section class="single-column__section">
        <h2 class="single-column__heading">アカウント管理情報の登録</h2>
        <div class="single-column__inner">
          <div class="profile-edit__head-text">
            <span>ご登録ありがとうございます。</span>
            <br>
            アカウント管理情報を登録してください。
          </div>
          <div class="profile-info">
            <form>
              <div class="form-wrap form-wrap--profile u-no-margin-top">
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="company_name">法人名
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="form-item--with-caution">
                      <input
                        id="company_name"
                        v-model="company_name"
                        class="form-control form-control--w400"
                        type="text"
                        placeholder="例）ズーラ株式会社">
                      <span class="form-item-text--inline u-text-color--pink">
                        一度登録された内容は変更できません。
                      </span>
                      <p class="error-text">〇〇が入力されていません</p>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="representative">代表者名
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="form-item--with-caution">
                      <input
                        id="representative"
                        v-model="representative"
                        class="form-control form-control--w400"
                        type="text"
                        placeholder="例）山田太郎">
                      <span class="form-item-text--inline u-text-color--pink">一度登録された内容は変更できません。
                        <br>姓名の順で入力してください。
                      </span>
                    </div>
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="establishment_year">設立日
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="form-item--with-caution">
                      <div class="form-item-inline form-item-inline--sp-reset">
                        <span class="form-item__wrap">
                          <div class="c-select_wrap">
                            <select
                              id="establishment_year"
                              v-model="establishment_year"
                              class="form-control c-select">
                              <option
                                value="0"
                                selected="selected">
                              </option>
                              <option value="1">2019</option>
                              <option value="2">2018</option>
                              <option value="3">2017</option>
                              <option value="4">2016</option>
                              <option value="5">2015</option>
                              <option value="6">2014</option>
                              <option value="7">2013</option>
                              <option value="8">2013</option>
                              <option value="9">2013</option>
                              <option value="10">2012</option>
                              <option value="11">2011</option>
                              <option value="12">2010</option>
                              <option value="13">2009</option>
                              <option value="14">2008</option>
                              <option value="15">2007</option>
                              <option value="16">2006</option>
                              <option value="17">2005</option>
                              <option value="18">2004</option>
                              <option value="19">2003</option>
                              <option value="20">2002</option>
                              <option value="21">2001</option>
                              <option value="22">2000</option>
                              <option value="23">1999</option>
                              <option value="24">1998</option>
                              <option value="25">1997</option>
                              <option value="26">1996</option>
                              <option value="27">1995</option>
                              <option value="28">1994</option>
                              <option value="29">1993</option>
                              <option value="30">1992</option>
                              <option value="31">1991</option>
                              <option value="32">1990</option>
                            </select>
                          </div>
                          <span class="c-select_wrap__text">年</span>
                        </span>
                        <span class="form-item__wrap">
                          <div class="c-select_wrap">
                            <select
                              id="establishment_month"
                              v-model="establishment_month"
                              class="form-control c-select">
                              <option
                                value="0"
                                selected="selected">
                              </option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                          </div>
                          <span class="c-select_wrap__text">月</span>
                        </span>
                        <span class="form-item__wrap">
                          <div class="c-select_wrap">
                            <select
                              id="establishment_day"
                              v-model="establishment_day"
                              class="form-control c-select">
                              <option
                                value="0"
                                selected="selected">
                              </option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>
                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                              <option value="23">23</option>
                              <option value="24">24</option>
                              <option value="25">25</option>
                              <option value="26">26</option>
                              <option value="27">27</option>
                              <option value="28">28</option>
                              <option value="29">29</option>
                              <option value="30">30</option>
                              <option value="31">31</option>
                            </select>
                          </div>
                          <span class="c-select_wrap__text">日</span>
                        </span>
                      </div>
                      <span class="form-item-text--inline u-text-color--pink">
                        一度登録された内容は変更できません。
                      </span>
                      <p class="error-text">〇〇が入力されていません</p>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="staff">担当者名
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="staff"
                      v-model="staff"
                      class="form-control"
                      type="text"
                      placeholder="例）山田太郎">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="tel">電話番号
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="tel"
                      v-model="tel"
                      class="form-control"
                      type="text"
                      placeholder="例）0312345678">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="zip_1">郵便番号
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="zip_1"
                      v-model="zip_1"
                      class="form-control form-control--postal1"
                      type="text"
                      placeholder="123"> ー
                    <input
                      id="zip_2"
                      v-model="zip_2"
                      class="form-control form-control--postal2"
                      type="text"
                      placeholder="1234">
                    <a
                      class="c-btn c-btn--postal"
                      href="">検索
                      <span class="c-btn__icon-arrow"></span>
                    </a>
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="pref">都道府県
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="c-select_wrap">
                      <select
                        id="pref"
                        v-model="pref"
                        class="form-control c-select"
                        name="language">
                        <option
                          value=""
                          disabled
                          selected
                          style="display:none;">
                          選択してください
                        </option>
                        <option value="1">北海道</option>
                        <option value="2">青森県</option>
                        <option value="3">岩手県</option>
                        <option value="4">宮城県</option>
                        <option value="5">秋田県</option>
                        <option value="6">山形県</option>
                        <option value="7">福島県</option>
                        <option value="8">茨城県</option>
                        <option value="9">栃木県</option>
                        <option value="10">群馬県</option>
                        <option value="11">埼玉県</option>
                        <option value="12">千葉県</option>
                        <option value="13">東京都</option>
                        <option value="14">神奈川県</option>
                        <option value="15">新潟県</option>
                        <option value="16">富山県</option>
                        <option value="17">石川県</option>
                        <option value="18">福井県</option>
                        <option value="19">山梨県</option>
                        <option value="20">長野県</option>
                        <option value="21">岐阜県</option>
                        <option value="22">静岡県</option>
                        <option value="23">愛知県</option>
                        <option value="24">三重県</option>
                        <option value="25">滋賀県</option>
                        <option value="26">京都府</option>
                        <option value="27">大阪府</option>
                        <option value="28">兵庫県</option>
                        <option value="29">奈良県</option>
                        <option value="30">和歌山県</option>
                        <option value="31">鳥取県</option>
                        <option value="32">島根県</option>
                        <option value="33">岡山県</option>
                        <option value="34">広島県</option>
                        <option value="35">山口県</option>
                        <option value="36">徳島県</option>
                        <option value="37">香川県</option>
                        <option value="38">愛媛県</option>
                        <option value="39">高知県</option>
                        <option value="40">福岡県</option>
                        <option value="41">佐賀県</option>
                        <option value="42">長崎県</option>
                        <option value="43">熊本県</option>
                        <option value="44">大分県</option>
                        <option value="45">宮崎県</option>
                        <option value="46">鹿児島県</option>
                        <option value="47">沖縄県</option>
                      </select>
                    </div>
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="address">市区町村 / 番地
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="address"
                      v-model="address"
                      class="form-control"
                      type="text"
                      placeholder="例）東京都渋谷区道玄坂1-1-1">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="building">建物名
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="building"
                      v-model="building"
                      class="form-control"
                      type="text"
                      placeholder="例）江戸ビル1111">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
              </div>
              <h3 class="form-subtitle">お取引先口座</h3>
              <div class="form-wrap form-wrap--profile u-no-margin-top">
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="bank_name">銀行名
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="bank_name"
                      v-model="bank_name"
                      class="form-control"
                      type="text"
                      placeholder="銀行名を入力してください">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="bank_branch">支店名
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="bank_branch"
                      v-model="bank_branch"
                      class="form-control"
                      type="text"
                      placeholder="支店名を入力してください">
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="bank_account_type">口座種別
                    </label>
                  </div>
                  <div class="form-item">
                    <div class="c-select_wrap">
                      <select
                        id="bank_account_type"
                        v-model="bank_account_type"
                        class="form-control c-select"
                        name="language">
                        <option
                          value=""
                          disabled
                          selected
                          style="display:none;">
                          選択してください
                        </option>
                        <option value="1">普通預金</option>
                        <option value="2">当座預金</option>
                      </select>
                    </div>
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label">
                    <label
                      class="control-label"
                      for="bank_account_number">口座番号
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="bank_account_number"
                      v-model="bank_account_number"
                      class="form-control form-control--account-number"
                      type="text"
                      placeholder="例）000000000">
                    <span class="form-item-text--inline">7桁未満の場合は頭に0を記入してください。</span>
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label form-label--top">
                    <label
                      class="control-label"
                      for="bank_account_name">口座名義
                    </label>
                  </div>
                  <div class="form-item">
                    <input
                      id="bank_account_name"
                      v-model="bank_account_name"
                      class="form-control"
                      type="text"
                      placeholder="例）ヤマダタロウ">
                    <div class="form-item-text form-item-text--bottom">
                      <strong>カナもしくはアルファベットで記入してください</strong>
                      <br>
                      販売利益をアカウント管理者様にお支払するために必要な口座になりますので、お手元に通帳をご用意の上、お間違いないよう入力してください。
                      口座情報の不備により当社が振込をできなかった場合、銀行の組み戻し費用はアカウント管理者様の負担となります。
                    </div>
                    <p class="error-text">〇〇が入力されていません</p>
                  </div>
                </div>
              </div>
              <div class="c-btn-wrap">
                <a class="c-btn">内容を確認
                  <span class="c-btn__icon-arrow"></span>
                </a>
                <a class="c-btn c-btn--back c-btn--right">あとで設定
                  <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
                </a>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Edit',
  data() {
    return {
      company_name: '',
      representative: '',
      establishment_year: '',
      establishment_month: '',
      establishment_day: '',
      staff: '',
      tel: '',
      zip_1: '',
      zip_2: '',
      pref: '',
      address: '',
      building: '',
      bank_name: '',
      bank_branch: '',
      bank_account_type: '',
      bank_account_number: '',
      bank_account_name: '',
    }
  },
}
</script>

<style scoped>

</style>
